import { createClassName } from 'utils/createClassName';

import './navigationLinksLayoutStyles.scss';

export const createNavigationLinksLayoutClassName = createClassName(
  'navigation-links-layout'
);
